import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Const from 'constants/constant'

export default function useDirectory() {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const directory = pathname.split('/')[1]
  const isRN = directory === 'rn'
  const isTour = directory === 'tour' || directory === 'community'
  const isBCP = directory === 'bcp'

  const logoHeader = useMemo(() => {
    switch (directory) {
      case 'bcp':
        return '/logo/transparent_header_bcp.png'
      case 'rn':
        return '/logo/transparent_header_rn.png'
      default:
        return '/logo/transparent_header.png'
    }
  }, [directory])

  const getDirectory = () => {
    switch (directory) {
      case 'tour':
        return 'tour'
      case 'community':
        return 'tour'
      case 'bcp':
        return 'bcp'
      case 'rn':
        return 'rn'
      default:
        return 'shimizu'
    }
  }

  const getDirectoryThemeColor = () => {
    switch (directory) {
      case 'tour':
        return '#91DCE5'
      case 'community':
        return '#91DCE5'
      case 'bcp':
        return '#A1C6B4'
      case 'rn':
        return '#EECE90'
      default:
        return '#609DF9'
    }
  }

  const getDirectoryPrimaryColor = (hover = false) => {
    const baseColor = (() => {
      switch (directory) {
        case 'tour':
          return '#5f9ea0'
        case 'community':
          return '#5f9ea0'
        case 'bcp':
          return '#247f52'
        case 'rn':
          return '#c28e15'
        default:
          return '#3163b7'
      }
    })()

    if (!hover) return baseColor

    // Increase color intensity on hover (decrease brightness)
    const darkenColor = (hex: string, percent: number) => {
      const num = parseInt(hex.replace('#', ''), 16)
      const amt = Math.round(2.55 * percent)

      const R = Math.floor(num / 65536) - amt
      const G = Math.floor((num % 65536) / 256) - amt
      const B = (num % 256) - amt

      const clamp = (value: number) => {
        if (value < 0) return 0
        if (value > 255) return 255
        return value
      }

      const r = clamp(R)
      const g = clamp(G)
      const b = clamp(B)

      return `#${(r * 65536 + g * 256 + b).toString(16).padStart(6, '0')}`
    }

    return darkenColor(baseColor, 10)
  }

  const getDirectoryBasename = () => {
    switch (directory) {
      case 'tour':
        return '/tour'
      case 'bcp':
        return '/bcp'
      case 'rn':
        return '/rn'
      default:
        return ''
    }
  }

  const getBuiildingType = () => {
    switch (directory) {
      case 'tour':
      case 'community':
        return 10
      case 'bcp':
        return 20
      case 'rn':
        return 30
      default:
        return 0
    }
  }

  const getBuiildingFolderList = () => {
    switch (directory) {
      case 'tour':
        return Const.TOUR_BUILDING_FOLDER
      case 'bcp':
        return Const.BCP_BUILDING_FOLDER
      case 'rn':
        return Const.RN_BUILDING_FOLDER
      default:
        return Const.TORISETSU_BUILDING_FOLDER
    }
  }

  const getAnnotationList = () => {
    switch (directory) {
      case 'tour':
        return Const.TOUR_ANNOTATION_LIST
      case 'bcp':
        return Const.BCP_ANNOTATION_LIST
      case 'rn':
        return Const.RN_ANNOTATION_LIST
      default:
        return Const.TORISETSU_ANNOTATION_LIST
    }
  }

  const handleDirectoryNavigate = (url: string) => {
    navigate(`${getDirectoryBasename()}${url}`)
  }

  return {
    pathname,
    logoHeader,
    rrdNavigate: navigate,
    navigate: handleDirectoryNavigate,
    directory,
    isRN,
    isTour,
    isBCP,
    getDirectory,
    getDirectoryThemeColor,
    getDirectoryBasename,
    getBuiildingType,
    getDirectoryPrimaryColor,
    getBuiildingFolderList,
    getAnnotationList
  }
}
